import { Button, ButtonProps } from "@outschool/backpack";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { addParamsToUrl } from "@outschool/routes";
import { AuthTrigger } from "@outschool/ui-auth";
import React from "react";
import { useHistory, useLocation } from "react-router";

import ActionType from "../actions/ActionType";
import { useAppState } from "../stores/AppStateProvider";

export default function JoinAndWelcomeButton(props: ButtonProps) {
  const appState = useAppState();
  const location = useLocation();
  const history = useHistory();

  return (
    <Button
      variant="contained"
      {...props}
      onClick={(e: any) => {
        history.push(
          addParamsToUrl(location.pathname, {
            ...location.query,
            authTrigger: `${AuthTrigger.ACTIVATE_OFFER}`,
            signup: true
          }),
          { noScroll: true }
        );

        props.onClick?.(e);

        appState.appDispatcher.dispatch(ActionType.Webapp.WELCOME_AFTER_LOGIN, {
          location
        });
      }}
    />
  );
}
